import { render } from "./SolutionIndex.vue?vue&type=template&id=56638e8d&scoped=true"
import script from "./SolutionIndex.vue?vue&type=script&lang=js"
export * from "./SolutionIndex.vue?vue&type=script&lang=js"

import "./SolutionIndex.vue?vue&type=style&index=0&id=56638e8d&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56638e8d"]])

export default __exports__